A certification or license held by the candidate.
